import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import MultilineTrim from 'widgets/MultilineTrim/MultilineTrim';
import { getOfferLink } from 'apps/catalogue/links';
import OfferType from '../../../products/models/OfferType';

import FopTrackLink from '../../analytics/components/FopTrackLink';

const OFFER_TYPE_TO_CLASS_MAPPING = {
  [OfferType.REGULAR]: 'promotion-offer',
  [OfferType.BUNDLE]: 'promotion-offer',
  [OfferType.COMBO]: 'promotion-offer',
  [OfferType.SMART_PASS]: 'discount-club-offer',
  [OfferType.SMART_PASS_ELIGIBLE]: 'discount-club-eligibility',
  [OfferType.SELLING_GROUP]: 'promotion-offer', // TODO check if proper class
  [OfferType.CHECKOUT_PURGE]: 'promotion-offer', // TODO check if proper class
};

export default class OfferDescription extends PureComponent {
  static propTypes = {
    bopUrl: PropTypes.string.isRequired,
    citrusAdData: PropTypes.object,
    gtmData: PropTypes.object,
    gtmDataUrl: PropTypes.string.isRequired,
    gtmEvent: PropTypes.string.isRequired,
    isClickable: PropTypes.bool.isRequired,
    offer: PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string,
      type: PropTypes.oneOf(Object.keys(OfferType)),
    }),
    productWarning: PropTypes.bool,
    routerPush: PropTypes.func.isRequired,
    moreExclusiveOffer: PropTypes.shape({
      moreOffersUrl: PropTypes.string,
      isMoreCardCustomer: PropTypes.bool,
    }),
  };

  get url() {
    const { bopUrl, offer, moreExclusiveOffer = {} } = this.props;
    const { isMoreCardCustomer, moreOffersUrl } = moreExclusiveOffer;
    const isSmartPass = offer.type === OfferType.SMART_PASS;

    if (isMoreCardCustomer && isSmartPass) {
      return moreOffersUrl;
    }

    const offerUrl = getOfferLink(offer);

    return offerUrl || bopUrl;
  }

  render() {
    const { url } = this;
    const {
      citrusAdData,
      gtmData,
      gtmEvent,
      gtmDataUrl,
      isClickable,
      offer,
      productWarning,
      routerPush,
    } = this.props;

    const offerClassNames = classNames(
      'fop-row-promo',
      OFFER_TYPE_TO_CLASS_MAPPING[offer.type],
      { 'fop-row-promo-warning': productWarning },
      { 'fop-row-promo-not-clickable': !isClickable },
    );

    if (!isClickable) {
      return (
        <div className={offerClassNames}>
          <MultilineTrim maxLines={2} trimMargin={10}>
            {offer.text}
          </MultilineTrim>
        </div>
      );
    }

    return (
      <FopTrackLink
        className={offerClassNames}
        citrusAdData={citrusAdData}
        gtmData={gtmData}
        gtmEvent={gtmEvent}
        gtmDataUrl={gtmDataUrl}
        routerPush={routerPush}
        to={url}
      >
        <MultilineTrim maxLines={2} trimMargin={10}>
          {offer.text}
        </MultilineTrim>
      </FopTrackLink>
    );
  }
}
